import { SVGObject } from "../svgobject";

export class SVGArchitecture18 extends SVGObject{
    public drawObject():void{
		super.initObject();
        this.svg =`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20000303 Stylable//EN" "http://www.w3.org/TR/2000/03/WD-SVG-20000303/DTD/svg-20000303-stylable.dtd"[]><svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 291 499"><path style="fill:#7f7f7f;stroke:#4c4c4c;stroke-width:2" d="M0,499 l134,-134 22,0 135,134 -291,0z" /><path style="fill:#7f7f7f;stroke:#4c4c4c;stroke-width:2" d="M139,365 l12,0 0,-365 -12,0 0,365z" /><path style="fill:#ccc" d="M154,368 l-8,0 47,128 38,0 -77,-128z" /><path style="fill:#fff" d="M148,368 l55,128 18,0 -70,-129 -3,1z" /></svg>`
		super.fillGradients();
        super.drawObject();
    }
}